export const selectSettingsLoading = (state) => state?.settings?.loading;
export const selectSettingsData = (state) => state?.settings?.settingsData;
